import React, {Component} from 'react';
import KeyMapper from '../prototypes/KeyMapper';

export class Dialog extends Component {

  constructor( props ){
    super( props );
    this.state = {
      keyMapper: new KeyMapper(),
      show: this.props.show === undefined ? false : this.props.show,
      width: this.props.width === undefined ? 50 : parseInt( this.props.width, 10 ),
      height: this.props.height === undefined ? 50 : parseInt( this.props.height, 10 ),
      hasError: false,
      error: {},
      info: {}
    };

    // Dialog Events
    this.onClose = this.onClose.bind( this );

    // Shortucut events
    this.shortcutKeys = this.shortcutKeys.bind( this );
    this.loadKeyMaps = this.loadKeyMaps.bind( this );
    this.onPressedEscape = this.onPressedEscape.bind( this );

  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentDidMount() {
    
    window.addEventListener( 'keydown', this.shortcutKeys );

    this.loadKeyMaps();
  }

  componentWillUnmount() {
    
    window.removeEventListener( 'keydown', this.shortcutKeys );

  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      show: nextProps.show === undefined ? false : nextProps.show,
      width: nextProps.width === undefined ? 50 : parseInt( nextProps.width, 10 ),
      height: nextProps.height === undefined ? 50 : parseInt( nextProps.height, 10 ),
    } );
  }

  onClose( e ) {
    if( this.props.onClose !== undefined ){
      this.props.onClose( e );
    }
  }

  loadKeyMaps() {
    let keyMapper = this.state.keyMapper;
    if( keyMapper !== undefined ) {
      keyMapper.addKeyMap( 'Escape', this.onPressedEscape );
      this.setState( {
        keyMapper: keyMapper
      } );
    }
  }

  shortcutKeys( e ) {
    const keyMapper = this.state.keyMapper;
    if( keyMapper !== undefined ) {
      const isVisible = this.state.show;
      if( isVisible === true ) {
        keyMapper.testKeyMap( e );
      }
    }
  }

  onPressedEscape( e ) {
    if( this.props.onClose !== undefined ){
      this.props.onClose( e );
    }
  }

  render() {
    const width = this.state.width;
    const height = this.state.height;
    const left = ( ( 100 - width ) / 2 );
    const top = ( ( 100 - height ) / 2 );

    const styleWidth = width.toString() + '%';
    const styleHeight = height.toString() + '%';
    const styleLeft = left.toString() + '%';
    const styleTop = top.toString() + '%';

    let dialog_styles = {
      top: styleTop,
      left: styleLeft,
      width: styleWidth,
      height: styleHeight,
    };

    // Updaing calculated styles with styles passed in
    if( this.props.style ){
      Object.assign( dialog_styles, this.props.style );
    }

    if( this.state.show === true && this.state.hasError === false ) {
      return (
        <div className="dialog" style={dialog_styles}>
          {this.props.children}
        </div>
      );
    } else {
      return (
        <span></span>
      );
    }
  }
}


// Special class allowing header items to be clicked and added to the clipboard, very similar to DialogHeader
// but brings hover differences and effects from clicking
export class DialogHeaderWithCopy extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      caption: this.props.caption === undefined ? '' : this.props.caption,
      copycaption: this.props.copycaption === undefined ? '' : this.props.copycaption,
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.onClose = this.onClose.bind( this );
    this.copyToClipboard = this.copyToClipboard.bind( this );
    this.resetCaption = this.resetCaption.bind( this );

    // Transition variables
    this._inTransition = false;
    this._transitionTrigger = undefined;
    this._ismounted = true;
    this._afterMountStyles = {};
  }

  componentDidMount(){
    this._ismounted = true;
    const domElement = document.getElementById( '#copytext' );
    if( domElement ){
      this._afterMountStyles = {
        width: domElement.clientWidth
      };
    }
  }

  componentWillUnmount(){
    this._ismounted = false;
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      caption: nextProps.caption === undefined ? '' : nextProps.caption,
      copycaption: nextProps.copycaption === undefined ? '' : nextProps.copycaption
    } );
  }

  onClose( e ) {
    if( this.props.onClose !== undefined ){
      this.props.onClose( e );
    }
  }

  // Copies the text to the users clipboard
  copyToClipboard( e ){
    if( this._inTransition === false ){
      this._transitionTrigger = setTimeout( this.resetCaption, 500 );
      this._inTransition = true;
      const copyCaption = this.state.copycaption;

      const el = document.createElement( 'textarea' );
      el.value = copyCaption;
      document.body.appendChild( el );
      el.select();
      document.execCommand( 'copy' );
      document.body.removeChild( el );

      if( this._ismounted ){
        this.setState( {
          prevcaption: copyCaption,
          copycaption: 'Copied'
        } );
      }
    }
  }

  // Sets the value back and allows it to be clicked to copy again
  resetCaption(){
    this._inTransition = false;
    this._transitionTrigger = undefined;
    const prevCopyCaption = this.state.prevcaption;

    if( this._ismounted ){
      this.setState( {
        copycaption: prevCopyCaption
      } );
    }
  }

  // Renders a two stage header depending if a copyheader is defined
  render() {

    const hasCloseButton = this.props.closeButton === undefined ? false : true;
    let copyButtonClass = 'dialog-header-copy-text';

    if( this._inTransition ){
      copyButtonClass = 'dialog-header-copy-text-clicked';
    }

    if( this.state.hasError === false ) {
      
      // None close button render
      if( hasCloseButton === false ) {
        
        // Copy enabled selection
        if( this.state.copycaption !== '' ){
          return (
            <div style={this.props.style} className="dialog-header">
              <span className={'dialog-header-text'}>{this.state.caption}</span>
              <span id={'#copytext'} className={copyButtonClass} style={this._afterMountStyles} onClick={this.copyToClipboard}> {this.state.copycaption} </span>
            </div>
          );

        // None copy enabled selection
        } else {
          return (
            <div style={this.props.style} className="dialog-header">
              <span className={'dialog-header-text'}>{this.state.caption}</span>
            </div>
          );
        }

      // Close button render
      } else {

        if( this.state.copycaption !== '' ){
          return (
            <div style={this.props.style} className="dialog-header">
              <span className={'dialog-header-text'}>{this.state.caption}</span>
              <span id={'#copytext'} className={copyButtonClass} style={this._afterMountStyles} onClick={this.copyToClipboard}> {this.state.copycaption} </span>
              <i className="dialog-header-close-button icon-ikons-close" onClick={this.onClose} />
            </div>
          );
        
        // Standard none copy enabled, this is the same return as a regular header
        } else {
          return (
            <div style={this.props.style} className="dialog-header">
              <span className={'dialog-header-text'}>{this.state.caption}</span>
              <i className="dialog-header-close-button icon-ikons-close" onClick={this.onClose} />
            </div>
          );
        }
      }
    } else {
      return ( <span></span> );
    }
  }
}


export class DialogHeader extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      caption: this.props.caption === undefined ? '' : this.props.caption,
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.onClose = this.onClose.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      caption: nextProps.caption === undefined ? '' : nextProps.caption
    } );
  }

  onClose( e ) {
    if( this.props.onClose !== undefined ){
      this.props.onClose( e );
    }
  }

  render() {

    const hasCloseButton = this.props.closeButton === undefined ? false : true;

    if( this.state.hasError === false ) {
      if( hasCloseButton === false ) {
        return (
          <div style={this.props.style} className="dialog-header">
            <span className={'dialog-header-text'}>{this.state.caption}</span>
          </div>
        );
      } else {
        return (
          <div style={this.props.style} className="dialog-header">
            <span className={'dialog-header-text'}>{this.state.caption}</span>
            <i className="dialog-header-close-button icon-ikons-close" onClick={this.onClose} />
          </div>
        );
      }
    } else {
      return ( <span></span> );
    }
  }
}

export class DialogBody extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  render() {
    const style = this.props.style === undefined ? {} : this.props.style;
    if( this.state.hasError === false ) {
      return (
        <div className={this.props.className === undefined ? 'dialog-body' : this.props.className} style={style} >
          {this.props.children}
        </div>
      );
    } else {
      return ( <div></div> );
    }
  }
}

export class DialogFooter extends React.Component {

  constructor( props ) {
    super( props );
    this.state = {
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  render() {
    if( this.state.hasError === false ){
      return (
        <div className="dialog-footer">
          {this.props.children}
        </div>
      );
    } else {
      return (
        <div></div>
      );
    }
  }
}

export class DialogPanel extends Component {
  render(  ) {
    return (
      <div className="dialog-panel">
        {this.props.children}
      </div>
    )
  }
}

export class DialogPanelControl extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      height: props.height === undefined ? 'auto' : props.height,
      width: props.width === undefined ? 'auto' : props.width
    };
  }

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = false;

    if( props.height !== undefined ) {
      if( props.height !== state.height ) {
        newState.height = props.height;
        stateChanged = true;
      }
    }

    if( props.width !== undefined ) {
      if( props.width !== state.width ) {
        newState.width = props.width;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  getStyle = ( ) => { 
    let style = {};
    
    if( this.state.height !== 'auto' ) {
      style.height = 'auto';
      style.minHeight = this.state.height;
    }

    if( this.state.width !== 'auto' ) {
      style.width = 'auto';
      style.minWidth = this.state.width;
    }

    return style;
  }

  render( ) {
    return (
      <div className="dialog-panel-control" style={this.getStyle()}>
        {this.props.children}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/presentation/Dialog.js